<template>
  <FamilyDrawerHeader sub-title="Lägg till extra mobilabonnemang" />
  <div
    class="pt-24 md:pt-32 px-16 md:px-24 pb-32 mb-32 border-b-md border-solid border-border-secondary"
  >
    <FamilySelectNewOrExistingPlanBox
      current-customer-btn-text="Beställ familjeanslutning"
    />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped></style>
